export default "__VITE_ASSET__CVYT$0d0__"